import { TextMaterialCategory } from '@@partner:types:app'
import { gql, useQuery } from '@apollo/client'



export interface AllTextMaterialCategories {
  allTextMaterialCategories: TextMaterialCategory[]
}

export const GQL_QUERY_ALL_TEXT_MATERIAL_CATEGORIES = gql`
  query {
    allTextMaterialCategories {
      id
      created_at
      updated_at
      name
      title
      slug
      status
      parent {
        id
        created_at
        updated_at
      }
      activeFrom
      activeUntil
      priority_weight
      i18n {
        languageCode
        title
      }
      defaultLanguage
    }
  }
`

export const useFetchAllTextMaterialCategories = () => 
  useQuery<AllTextMaterialCategories>(GQL_QUERY_ALL_TEXT_MATERIAL_CATEGORIES)